export default __webpack_public_path__ + "static/media/cpr6.362cea3d.jpg";